import cardsStore from "@/app/settings/store/cards";
import settingsStore from "@/app/settings/store/settings";
export default {
  modules: {
    cardsStore,
    settingsStore,
  },
};
